import { render, staticRenderFns } from "./ActiveQueueReportSort.vue?vue&type=template&id=5d8b9b57&"
import script from "./ActiveQueueReportSort.vue?vue&type=script&lang=js&"
export * from "./ActiveQueueReportSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports